function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import NavPath from "../NavPath/NavPath";
import NavAction from "../NavAction/NavAction";
import ActionButton from "../NavAction/ActionButton";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "inherit",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    flexDirection: "column"
  },
  header: {
    flexGrow: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    maxWidth: "100%",
    width: "100%",
    minHeight: theme.spacing(8)
  },
  navPath: {
    margin: theme.spacing(0, 2)
  },
  closeButton: {
    margin: theme.spacing(1)
  },
  body: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column"
  },
  footer: {
    flexGrow: 0,
    display: "flex",
    margin: theme.spacing(2),
    "& > * + *": {
      marginLeft: theme.spacing(2)
    }
  },
  preview: {
    minHeight: theme.spacing(32),
    position: "relative",
    margin: theme.spacing(1)
  },
  content: {
    flexBasis: 0,
    flexGrow: 1
  }
}));

const CloseButton = ({
  className,
  onClick
}) => {
  return React.createElement(IconButton, {
    className: className,
    onClick: onClick
  }, React.createElement(CloseIcon, null));
};

const BulkEditor = (_ref) => {
  let preview = _ref.preview,
      title = _ref.title,
      primaryAction = _ref.primaryAction,
      secondaryAction = _ref.secondaryAction,
      children = _ref.children,
      onClose = _ref.onClose,
      props = _objectWithoutPropertiesLoose(_ref, ["preview", "title", "primaryAction", "secondaryAction", "children", "onClose"]);

  const classes = useStyles();

  const renderPreview = () => {
    const PreviewTemplate = preview && preview.template;

    if (!PreviewTemplate) {
      return false;
    }

    return React.createElement("div", {
      className: classes.preview
    }, PreviewTemplate && React.createElement(PreviewTemplate, preview) || JSON.stringify(preview));
  };

  return React.createElement("div", {
    className: classes.root
  }, React.createElement("header", {
    className: classes.header
  }, React.createElement(NavPath, {
    className: classes.navPath,
    title: title
  }), React.createElement(CloseButton, {
    className: classes.closeButton,
    onClick: onClose
  })), React.createElement("div", {
    className: classes.body
  }, renderPreview(), React.createElement("div", {
    className: classes.content
  }, children)), React.createElement("footer", {
    className: classes.footer
  }, React.createElement(NavAction, {
    primaryAction: primaryAction
  }), secondaryAction && React.createElement(NavAction, {
    primaryAction: secondaryAction
  })));
};

export default BulkEditor;